import { render, staticRenderFns } from "./Solo.vue?vue&type=template&id=4ed1c202&scoped=true&"
import script from "./Solo.vue?vue&type=script&lang=js&"
export * from "./Solo.vue?vue&type=script&lang=js&"
import style0 from "./Solo.vue?vue&type=style&index=0&id=4ed1c202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1c202",
  null
  
)

export default component.exports